@if (isLoading() && editedHealthHistoryItemId() === null) {
  <ng-lottie [options]="lottieOptions" currentColor class="mx-auto my-auto w-5 text-primary-blue"></ng-lottie>
} @else {
  <lib-health-history-filter [filterState]="filterState()" (filterChanged)="onFilterChanged($event)"></lib-health-history-filter>
  <lib-health-history-section
    titleTranslationKey="health_history_health_history_tab_medical_conditions"
    emptyTextTranslationKey="health_history_health_history_tab_medical_conditions_empty_text"
    [healthHistorySection]="medicalConditionsSection()"
    [isLoading]="isLoading()"
    [addHealthHistoryEnabled]="addHealthHistoryEnabled()"
    [editHealthHistoryEnabled]="editHealthHistoryEnabled()"
    [deleteHealthHistoryEnabled]="deleteHealthHistoryEnabled()"
    (changeEditMode)="setEditMode($event)"
    (deleteItem)="onDeleteItem($event, HealthHistoryType.MedicalCondition)"
    (addNewItem)="onAddNewItem($event)"
    (saveItem)="onSaveItem($event, HealthHistoryType.MedicalCondition)"
    (discardNewItem)="onDiscardNewItem()"
  ></lib-health-history-section>
  <lib-health-history-section
    titleTranslationKey="health_history_health_history_tab_allergies"
    emptyTextTranslationKey="health_history_health_history_tab_allergies_empty_text"
    [healthHistorySection]="allergiesSection()"
    [isLoading]="isLoading()"
    [addHealthHistoryEnabled]="addHealthHistoryEnabled()"
    [editHealthHistoryEnabled]="editHealthHistoryEnabled()"
    [deleteHealthHistoryEnabled]="deleteHealthHistoryEnabled()"
    (changeEditMode)="setEditMode($event)"
    (deleteItem)="onDeleteItem($event, HealthHistoryType.Allergy)"
    (addNewItem)="onAddNewItem($event)"
    (saveItem)="onSaveItem($event, HealthHistoryType.Allergy)"
    (discardNewItem)="onDiscardNewItem()"
  ></lib-health-history-section>
  <lib-health-history-section
    titleTranslationKey="health_history_health_history_tab_patient_reported_medications"
    emptyTextTranslationKey="health_history_health_history_tab_patient_reported_medications_empty_text"
    [healthHistorySection]="patientReportedMedicationsSection()"
    [isLoading]="isLoading()"
    [addHealthHistoryEnabled]="addHealthHistoryEnabled()"
    [editHealthHistoryEnabled]="editHealthHistoryEnabled()"
    [deleteHealthHistoryEnabled]="deleteHealthHistoryEnabled()"
    (changeEditMode)="setEditMode($event)"
    (deleteItem)="onDeleteItem($event, HealthHistoryType.PatientReportedMedication)"
    (addNewItem)="onAddNewItem($event)"
    (saveItem)="onSaveItem($event, HealthHistoryType.PatientReportedMedication)"
    (discardNewItem)="onDiscardNewItem()"
  ></lib-health-history-section>
}
